import React, { useEffect } from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "animate.css";
import WOW from "wowjs";

function ContactCard() {
  useEffect(() => {
    // Initialize WOW.js for scroll animations
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  const contactInfo = [
    { icon: <FaPhone />, label: "Phone", value: "+91-7387731718" },
    { icon: <FaEnvelope />, label: "Email", value: "thechallengeofeverestgame@gmail.com" },
    { icon: <FaMapMarkerAlt />, label: "Address", value: "Bramhan Ali Road At Post Awasari bk, Tal Ambegaon,     Dist Pune 412406" },
  ];

  return (
    <div className="contact-card">
      {contactInfo.map((info, index) => (
        <div 
          key={index} 
          className="contact-card-item wow animate__animated animate__fadeInUp"
          data-wow-duration="1.5s"
          data-wow-delay={`${0.2 * index}s`} // Adds staggered delays to each item
        >
          <span className="icon">{info.icon}</span>
          <div className="contact-details">
            <h4>{info.label}</h4>
            <p>{info.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ContactCard;
